/* eslint-disable camelcase */

export const assessmentsFormatter = (data) => data.map((assessment) => ({
  id: assessment.id,
  name: assessment.name,
}));

export default assessmentsFormatter;
